import { Notification } from "hooks/useNotifications"

export const getNotificationLinkUrl = (notifcation: Notification) => {
  if (notifcation.notificationType === `Product Update Rejected`) {
    const id = notifcation.url.split(`/`).filter(Boolean).at(-1)
    return `/products/${id}`
  }

  return notifcation.url
}

export const getNotificationLinkText = (notification: Notification) => {
  switch (notification.notificationType) {
    case `Product Update Rejected`:
      return `View product`
    case `Order Item Allocated`:
      return `View order`
    default:
      return `View`
  }
}
